import { inject, Pipe, PipeTransform } from '@angular/core';
import { CustomDatePipe } from './custom-date.pipe';

@Pipe({
	name: 'subscriptionDate',
})
export class SubscriptionDatePipe implements PipeTransform {
	private datePipe = inject(CustomDatePipe);
	transform(value: number): string | null {
		if (!value || value <= 0) {
			return '-';
		}
		return this.datePipe.transform(value * 1000);
	}
}
